import { BUNDLED_REFERENCE } from "./referenceData";

// PER-STATE FERTILIZER PRICES — generated from his THE PHOSPHATE PRODUCT VARIES BY STATE, and it is
// not only a price difference: some states publish MAP (11-52-0, 1,040 lbs P2O5/ton) and some only
// DAP (18-46-0, 920 lbs P2O5/ton), so the TONS a claim converts to change with the product. Each
// row therefore carries its own product price AND lbs-per-ton, and the report divides by the row's
// figure rather than a global constant.

export interface StatePrice {
  phosphateProduct: "MAP" | "DAP";
  phosphatePricePerTon: number;
  phosphateLbsPerTon: number;
  potashPricePerTon: number;
  dataClass: string;
}

export const STATE_PRICES: Record<string, StatePrice> = {
  ...BUNDLED_REFERENCE["state-prices"].states,
} as Record<string, StatePrice>;

export function installStatePrices(doc: {
  states: Record<string, StatePrice>;
}): void {
  for (const key of Object.keys(STATE_PRICES)) delete STATE_PRICES[key];
  Object.assign(STATE_PRICES, doc.states);
}

/* * Does the platform publish a priceable market for this state? ('NA' — outside the 50 — never). */
export const hasStatePricing = (state: string | undefined): boolean =>
  state != null && state in STATE_PRICES;

/* * Every selected state that the ROGO Default cannot price. */
export const unpricedStates = (states: string[]): string[] =>
  states.filter((s) => !hasStatePricing(s));
